import React, { Component } from "react";
import "./update-banner.scss";

class UpdateBanner extends Component {

    render() {

        const {
            visible,
            currentVersion,
            latestVersion,
            onRestart,
            onLater
        } = this.props;

        if (!visible) return null;

        return (

            <div className="cw-update-banner">

                <div className="cw-update-icon">
                    ⬆️
                </div>

                <div className="cw-update-content">

                    <h5>
                        Update Available
                    </h5>

                    <div className="cw-update-message">

                        <strong>
                            A new version of Countingwell is ready.
                        </strong>

                        <div className="cw-version">

                            Current Version :
                            <b>{currentVersion}</b>

                            <br />

                            Latest Version :
                            <b>{latestVersion}</b>

                        </div>

                        <div className="cw-description">

                            We've made improvements to enhance
                            performance, reliability and your overall
                            experience.

                        </div>

                    </div>

                    <div className="cw-buttons">

                        <button
                            className="restart-btn"
                            onClick={onRestart}>

                            Update Now

                        </button>

                        <button
                            className="later-btn"
                            onClick={onLater}>

                            Later

                        </button>

                    </div>

                </div>

            </div>

        );

    }

}

export default UpdateBanner;